import { render, staticRenderFns } from "./status_tag.vue?vue&type=template&id=4eb748ea&"
import script from "./status_tag.vue?vue&type=script&lang=js&"
export * from "./status_tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports